/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForFirmwareGroupsResponseByDateHour
 */
export interface ReportForFirmwareGroupsResponseByDateHour {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportForFirmwareGroupsResponseByDateHour
     */
    retries: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsResponseByDateHour
     */
    version: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsResponseByDateHour
     */
    groupSize: number | null;
}

export function ReportForFirmwareGroupsResponseByDateHourFromJSON(json: any): ReportForFirmwareGroupsResponseByDateHour {
    return ReportForFirmwareGroupsResponseByDateHourFromJSONTyped(json, false);
}

export function ReportForFirmwareGroupsResponseByDateHourFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForFirmwareGroupsResponseByDateHour {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retries': json['retries'],
        'version': json['version'],
        'groupSize': json['groupSize'],
    };
}

export function ReportForFirmwareGroupsResponseByDateHourToJSON(value?: ReportForFirmwareGroupsResponseByDateHour | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retries': value.retries,
        'version': value.version,
        'groupSize': value.groupSize,
    };
}

